import { render, staticRenderFns } from "./OrgCard.vue?vue&type=template&id=ca8d3c76&scoped=true&"
import script from "./OrgCard.vue?vue&type=script&lang=ts&"
export * from "./OrgCard.vue?vue&type=script&lang=ts&"
import style0 from "./OrgCard.vue?vue&type=style&index=0&id=ca8d3c76&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca8d3c76",
  null
  
)

export default component.exports